module.exports = __webpack_public_path__ + "assets/img/bg.35ea393c.jpg";